module.exports = __webpack_public_path__ + "img/ring_r_e_null_null@2x.32d693df.png";